module.exports = __webpack_public_path__ + "media/ab-homepage/no-custom-8ef7ce30.png";